/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateful
 */
import React from 'react';
import { COST_RULE, ABSENT_RULE, CANCEL_RULE} from 'data/constants'
import addLessonAttendance from 'controllers/lesson/addLessonAttendance'
import getStudentCheckNotes from 'controllers/lesson/getStudentCheckNotes'
import getTeacherCheckNotes from 'controllers/lesson/getTeacherCheckNotes'
import addStudentCheckNotes from 'controllers/lesson/addStudentCheckNotes'
import addTeacherCheckNotes from 'controllers/lesson/addTeacherCheckNotes'
import {fetchLessonAttendance} from './ducks'

import Loading from 'components/UI/Loading';

import './Modal.scss'

class ModalContent extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      open_student_note: {},
      open_teacher_note: {},
      student_note: '',
      teacher_note: '',
      teacherCheckedIn: {},
      studentCheckedIn: {},
      studentAbsent: {},
      teacherAbsent: {},
      studentAbsentWithoutNotice: {},
      status: '',
    }

    this.onStudentRemarkChange = this.onStudentRemarkChange.bind(this)
    this.onTeacherRemarkChange = this.onTeacherRemarkChange.bind(this)
    this.onChangeCheckInStatus = this.onChangeCheckInStatus.bind(this)
  }

  componentWillReceiveProps({ attendanceDetail }) {
    if(this.props.attendanceDetail !== attendanceDetail){
      const {student_list, teacher_list} = attendanceDetail

      if (student_list && teacher_list) {
        let open_student_note = {}
        let open_teacher_note = {}
        let teacherCheckedIn = {}
        let studentCheckedIn = {}
        let studentAbsent = {}
        let studentAbsentWithoutNotice = {}
        let teacherAbsent = {}
  
        student_list.forEach((student) => {
          open_student_note[student.student_id] = false;
          studentCheckedIn[student.student_id] = student.check_in_status === 1 || student.check_in_status === 3;
          studentAbsent[student.student_id] = student.check_in_status === 2;
          studentAbsentWithoutNotice[student.student_id] = student.check_in_status === 4;
        })
  
        teacher_list.forEach((teacher) => {
          open_teacher_note[teacher.teacher_id] = false;
          teacherCheckedIn[teacher.teacher_id] = teacher.check_in_status === 1;
          teacherAbsent[teacher.teacher_id] = teacher.check_in_status === 2;
  
        })
  
        this.setState({
          open_student_note,
          open_teacher_note,
          studentCheckedIn,
          teacherCheckedIn,
          studentAbsent,
          studentAbsentWithoutNotice,
          teacherAbsent,
        });
      }
    }
  }

  onStudentRemarkChange(event){
    this.setState({student_note: event.target.value})
  }

  onTeacherRemarkChange(event){
    this.setState({teacher_note: event.target.value})
  }

  renderStudentNote(student_id){
    let { student_note } = this.state;
    const lessonId = this.props.attendanceDetail.lesson_id

    if(this.state.open_student_note[student_id]){
      return(
        <div>
          <textarea className='form-control' value={this.state.student_note} onChange={this.onStudentRemarkChange} />
          <div className='container-fluid textarea-btn'>
            <i className='pull-right fa icon-ok' onClick={()=>{
              addStudentCheckNotes(lessonId, student_id, {checkin_note: student_note})
              .then((res) => { this.setState({open_student_note:{ student_id: false}}) })
            }}></i>
            <i className='pull-right fa icon-cancel' onClick={() => {
              this.setState({open_student_note: {student_id: false}})
            }}></i>
          </div>
        </div>
      )
    }
  }

  renderTeacherNote(teacher_id){
    let { teacher_note } = this.state;
    const lessonId = this.props.attendanceDetail.lesson_id

    if(this.state.open_teacher_note[teacher_id]){
      return(
        <div>
          <textarea className='form-control' value={this.state.teacher_note} onChange={this.onTeacherRemarkChange} />
          <div className='container-fluid textarea-btn'>
            <i className='pull-right fa icon-ok' onClick={()=>{
              addTeacherCheckNotes(lessonId, teacher_id, {checkin_note: teacher_note})
              .then((res) => { this.setState({open_teacher_note:{ teacher_id: false}}) })
            }}></i>
            <i className='pull-right fa icon-cancel' onClick={() => {
              this.setState({open_teacher_note: {teacher_id: false}})
            }}></i>
          </div>
        </div>
      )
    }
  }

  onStudentRemarksExpand(student) {
    return ()=>{
      const lessonId = this.props.attendanceDetail.lesson_id
      let { student_id } = student;
      let { open_student_note } = this.state;
      getStudentCheckNotes(lessonId, student_id)
      .then((res) => { this.setState({
        student_note: res.checkin_note,
        open_student_note: {
          [student_id]: open_student_note[student_id] !== true,
        }
      })})
    }
  }

  onTeacherRemarksExpand(teacher){
    return () => {
      const lessonId = this.props.attendanceDetail.lesson_id
      let { teacher_id } = teacher;
      let { open_teacher_note } = this.state;
      getTeacherCheckNotes(lessonId, teacher_id)
      .then((res) => {
        this.setState({
          teacher_note: res.checkin_note,
          open_teacher_note: {
            [teacher_id]: open_teacher_note[teacher_id] !== true
          }
        })
      })
    }
  }

  onChangeCheckInStatus(studentId){
    return (event)=> {
      const {dispatch} = this.props;
      const lessonId = this.props.attendanceDetail.lesson_id
      const status = event.target.value


      addLessonAttendance(lessonId, {is_teacher: 'student', id: studentId, check_in_status: status })
      .then((res) => {
        dispatch(fetchLessonAttendance(lessonId))
      })
    }
  }

  renderStudentSection(){
    const attendanceDetail = this.props.attendanceDetail
    const {studentCheckedIn, studentAbsent, studentAbsentWithoutNotice} = this.state

    return(
      attendanceDetail.student_list.map((student, index) => {
        return (
          <div className='container-fluid student-list-section' key={student.student_id}>
            <div className='name-section-wrapper'>
              <span className='attendance-student-name'>{student.student_name}</span>
              <span className='attend-remarks'>
                
              </span>
            </div>
            <div className='checkbox-section-wrapper'>
              <div className='checkbox-section'>
                <label className='control'>
                  <input
                    type='checkbox'
                    className='checkbox-input'
                    value={attendanceDetail.lesson_id}
                    id={'s-attended-'+index}
                    checked={studentCheckedIn[student.student_id]}
                    onClick={(event) => {
                      const {lesson_id} = attendanceDetail
                      const {student_id} = student
                      if(!this.state.studentCheckedIn[student_id]) {
                        this.setState({
                          studentCheckedIn: {
                            ...this.state.studentCheckedIn,
                            [student_id]: true,
                          },
                          studentAbsent: {
                            ...this.state.studentAbsent,
                            [student_id]: false,
                          },
                          studentAbsentWithoutNotice: {
                            ...this.state.studentAbsentWithoutNotice,
                            [student_id]: false,
                          }
                        });
                      }else {
                        this.setState({
                          studentCheckedIn: {
                            ...this.state.studentCheckedIn,
                            [student_id]: false,
                          }
                        });
                      }
                      if(event.target.checked){
                        addLessonAttendance(lesson_id, {is_teacher: 'student', id: student_id, check_in_status: 'attended'})
                      } else {
                        addLessonAttendance(lesson_id, {is_teacher: 'student', id: student_id, check_in_status: 'unchecked'})
                      }
                    }}
                  />
                  <span className='checkmark'></span>
                  <label className='attended-label' htmlFor={'s-attended-'+index}>{__('Attended', 'classdetail')}</label>
                </label>
              </div>
              <div className='checkbox-section'>
                <label className='control'>
                  <input
                    type='checkbox'
                    className='checkbox-input'
                    value={attendanceDetail.lesson_id}
                    id={'s-absent-with-excuse-'+index}
                    checked={studentAbsent[student.student_id]}
                    onClick={(event) => {
                      const {lesson_id} = attendanceDetail
                      const {student_id} = student
                      if(!this.state.studentAbsent[student_id]) {
                        this.setState({
                          studentAbsent: {
                            ...this.state.studentAbsent,
                            [student_id]: true,
                          },                      
                          studentCheckedIn: {
                            ...this.state.studentCheckedIn,
                            [student_id]: false,
                          },                      
                          studentAbsentWithoutNotice: {
                            ...this.state.studentAbsentWithoutNotice,
                            [student_id]: false,
                          }

                        });
                      } else {
                        this.setState({
                          studentAbsent: {
                            ...this.state.studentAbsent,
                            [student_id]: false,
                          }
                        });
                      }

                      if(event.target.checked){
                        addLessonAttendance(lesson_id, {is_teacher: 'student', id: student_id, check_in_status: 'absent (with excuse)'})
                      } else {
                        addLessonAttendance(lesson_id, {is_teacher: 'student', id: student_id, check_in_status: 'unchecked'})
                      }
                    }}
                  />
                  <span className='checkmark'></span>
                  <label className='attended-label' htmlFor={'s-absent-with-excuse-'+index}>{__('Absent (with excuse)', 'teacherAttendance')}</label>
                </label>
              </div>
              <div className='checkbox-section'>
                <label className='control'>
                  <input
                    type='checkbox'
                    className='checkbox-input'
                    value={attendanceDetail.lesson_id}
                    id={'s-absent-without-notice-'+index}
                    checked={studentAbsentWithoutNotice[student.student_id]}
                    onClick={(event) => {
                      const {lesson_id} = attendanceDetail
                      const {student_id} = student
                      if(!this.state.studentAbsentWithoutNotice[student_id]) {
                        this.setState({
                          studentAbsentWithoutNotice: {
                            ...this.state.studentAbsentWithoutNotice,
                            [student_id]: true,
                          },
                          studentCheckedIn: {
                            ...this.state.studentCheckedIn,
                            [student_id]: false,
                          },
                          studentAbsent: {
                            ...this.state.studentAbsent,
                            [student_id]: false,
                          },
                        });
                      }else {
                        this.setState({
                          studentAbsentWithoutNotice: {
                            ...this.state.studentAbsentWithoutNotice,
                            [student_id]: false,
                          },
                        });
                      }

                      if(event.target.checked){
                        addLessonAttendance(lesson_id, {is_teacher: 'student', id: student_id, check_in_status: 'absent (without notice)'})
                      } else {
                        addLessonAttendance(lesson_id, {is_teacher: 'student', id: student_id, check_in_status: 'unchecked'})
                      }
                    }}
                  />
                  <span className='checkmark'></span>
                  <label className='attended-label' htmlFor={'s-absent-without-notice-'+index}>{__('Absent (without notice)', 'teacherAttendance')}</label>
                </label>
              </div>
            </div>
            {this.renderStudentNote(student.student_id)}
          </div>
        )
      })
    )
  }

  renderTeacherSection(){

    const attendanceDetail = this.props.attendanceDetail
    const {teacherCheckedIn, teacherAbsent} = this.state

    return(
      attendanceDetail.teacher_list.map((teacher, index) => {
        return(
          <div className='container-fluid teacher-list-section' key={teacher.teacher_id}>
            <div className='name-section-wrapper'>
              <span className='attendance-teacher-name'>{teacher.teacher_name}</span>
              <span className='attend-teacher-remarks'>
                <button className='btn-link' onClick={this.onTeacherRemarksExpand(teacher)}>
                {__('Remark', 'classdetail')}
                </button>
              </span>
            </div>
            <div className='checkbox-section-wrapper'>
              <div className='checkbox-section'>
                <label className='control'>
                  <input
                    type='checkbox'
                    className='checkbox-input'
                    value={attendanceDetail.lesson_id}
                    id={'t-attended-'+index}
                    checked={teacherCheckedIn[teacher.teacher_id]}
                    onClick={(event) => {
                      const {lesson_id} = attendanceDetail
                      const {teacher_id} = teacher
                      if(!teacherCheckedIn[teacher.teacher_id]){
                        this.setState({
                          teacherCheckedIn: {
                            ...this.state.teacherCheckedIn,
                            [teacher_id]: true,
                          },
                          teacherAbsent: {
                            ...this.state.teacherAbsent,
                            [teacher_id]: false,
                          },
                        });
                      }else {
                        this.setState({
                          teacherCheckedIn: {
                            ...this.state.teacherCheckedIn,
                            [teacher_id]: false,
                          }
                        });
                      }

                      if(event.target.checked){
                        addLessonAttendance(lesson_id, {is_teacher: 'teacher', id: teacher_id, check_in_status: 'attended'})
                      } else {
                        addLessonAttendance(lesson_id, {is_teacher: 'teacher', id: teacher_id, check_in_status: 'unchecked'})
                      }
                    }}
                  />
                  <span className='checkmark'></span>
                  <label className='attended-label' htmlFor={'t-attended-'+index}>{__('Attended', 'classdetail')}</label>
                  </label>
              </div>
              <div className='checkbox-section'>
                <label className='control'>
                  <input
                    type='checkbox'
                    className='checkbox-input'
                    value={attendanceDetail.lesson_id}
                    id={'t-absent-with-excuse-'+index}
                    checked={teacherAbsent[teacher.teacher_id]}
                    onClick={(event) => {
                      const {lesson_id} = attendanceDetail
                      const {teacher_id} = teacher
                      
                      if(!teacherAbsent[teacher.teacher_id]){
                        this.setState({
                          teacherAbsent: {
                            ...this.state.teacherAbsent,
                            [teacher_id]: true,
                          },
                          teacherCheckedIn: {
                            ...this.state.teacherCheckedIn,
                            [teacher_id]: false,
                          },
                        });
                      }else {
                        this.setState({
                          teacherAbsent: {
                            ...this.state.teacherAbsent,
                            [teacher_id]: false,
                          }
                        });
                      }
                      if(event.target.checked){
                        addLessonAttendance(lesson_id, {is_teacher: 'teacher', id: teacher_id, check_in_status: 'absent (with excuse)'})
                      } else {
                        addLessonAttendance(lesson_id, {is_teacher: 'teacher', id: teacher_id, check_in_status: 'unchecked'})
                      }
                    }}
                  />
                  <span className='checkmark'></span>
                  <label className='attended-label' htmlFor={'t-absent-with-excuse-'+index}>{__('Absent (with excuse)', 'teacherAttendance')}</label>
                  </label>
              </div>
              <div className='checkbox-section'></div>
            </div>
            {this.renderTeacherNote(teacher.teacher_id)}
          </div>
        )
      })
    )
  }

  render() {
    const { detail, fetching } = this.props.classDetail;
    const classDetail = detail;
    const attendanceDetail = this.props.attendanceDetail;
    if(!attendanceDetail || !classDetail || Object.keys(classDetail).length < 1 || fetching == true || !attendanceDetail.start_datetime){
      return <Loading />
    }

    return (
      <div className='attendance-modal-content'>
        <div className='container-fluid'>
          <div className='attendance-rule-section'>
            <strong className='attendance-rule-label'>{__('Lesson Completion Rule: ', 'classdetail')}</strong>
            {COST_RULE[classDetail.costRule] + ' | ' + ABSENT_RULE[classDetail.absentFlag] + " | " + CANCEL_RULE[classDetail.cancelFlag]}
          </div>
          <div className='attendance-time-section'>
            <strong>{__('Lesson Time: ', 'classdetail')}</strong>
            <span>
              {__('{lsnStartDate1} - {lsnStartDate2} - {lsnStartDate3}  {lsnStartTime} - {lsnEndTime}', 'classdetail',
                {
                  lsnStartDate1: attendanceDetail.start_datetime.slice(0,4),
                  lsnStartDate2: attendanceDetail.start_datetime.slice(5,7),
                  lsnStartDate3: attendanceDetail.start_datetime.slice(8,10),
                  lsnStartTime: attendanceDetail.start_datetime.slice(11,18),
                  lsnEndTime: attendanceDetail.end_datetime.slice(11,18)}
              )}
            </span>
          </div>
          <div className='attendance-student-seciton'>
            <div className='attendance-student-label'><strong>{__('Students', 'class')}</strong></div>
            {this.renderStudentSection()}
          </div>
          <div className='attendance-teacher-seciton'>
            <div className='attendance-teacher-label'><strong>{__('Teacher', 'changeschool')}</strong></div>
            {this.renderTeacherSection()}
          </div>

        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/Attendance/ModalContent.js